module.exports = __webpack_public_path__ + "img/online--shopping.3a8febb1.svg";